module.exports = "\r\n<div *ngFor=\"let x of photoService.albums\" (click)=\"showAlbumPhoto(x)\" \r\nclass=\"{{x.empty ? 'unenabled_filter' : x == photoService.currentAlbum? 'hightlight_filter': 'unhightlight_filter' }}\"\r\n>\r\n\t{{x.albumName}}\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/html/panelFilter.html
// module id = 688
// module chunks = 1